// extracted by mini-css-extract-plugin
export default {"locationButton":"Map_locationButton__5A4nP","infoWrapper":"Map_infoWrapper__XL9Pf","confirmButton":"Map_confirmButton__uVe+8","cancelButton":"Map_cancelButton__jLfDZ"};